export default "__VITE_ASSET__8c3afbcc__"